@if (sidenav.opened && portal$ | async; as portal) {
  <ng-template [cdkPortalOutlet]="portal"></ng-template>
}
